import { StreetOrientationMode } from "building-types/building/streetOrientationMode";
import { BuiltInExteriorPropId } from "building-types/props/builtInExteriorPropId";
import { PropId } from "building-types/props/propIds";
import type { HomeSettings } from "building-types/settings/homeSettings";
import type { PorchSettings } from "building-types/settings/porchSettings";
import { SettingsType } from "building-types/settings/settingsType";
import {
  ColonnadeTerminationType,
  WallIntersectionType,
  EaveType,
  FasciaTopTrimSize,
} from "building-types/settings/settingsTypesEnum";
import { defaultExteriorPropCatalog } from "../elements/propCatalog/exteriorPropCatalog";
import { fasciaTopTrimSizeToValue } from "../fasciaTopTrimSizeToValue";
import { BuiltinHomeSettingsId, builtinHomeSettingsPrettyName } from "./builtinHomeSettingsId";
import {
  defaultFriezeBoardSettings,
  defaultHomeSettings,
  defaultPorchSettings,
  defaultWainscotingSettings,
} from "./defaultSettings";

const defaultBrockPorchSettings: PorchSettings = {
  ...defaultPorchSettings,
  maxColumnSpacing: 200,
  doorPathColumnSpread: 72,
  columnId: undefined,
  colonnadeTerminationRules: [
    {
      endType: WallIntersectionType.TEE,
      terminationType: ColonnadeTerminationType.COLUMN,
    },
  ],
};

const brockMaterials: { [id: string]: HomeSettings } = {
  [BuiltinHomeSettingsId.Brock_L30]: {
    ...defaultHomeSettings,
    name: builtinHomeSettingsPrettyName[BuiltinHomeSettingsId.Brock_L30],
    exteriorMaterials: {
      id: BuiltinHomeSettingsId.Brock_L30 + "_exterior",
      type: SettingsType.EXTERIOR_MATERIAL_SETTINGS,
      palettes: [BuiltinHomeSettingsId.Brock_L30],
    },
    roof: {
      type: SettingsType.ROOF_SETTINGS,
      eaveOverhang: 12,
      rakeOverhang: 12,
      shedOverhang: 12,
      eaveType: EaveType.ANGLED_ENCLOSED_OPEN,
      rakeBracketPropId: BuiltInExteriorPropId.RAKEBRACKET,
      includeFasciaTopTrim: true,
      fasciaTopTrimSize: fasciaTopTrimSizeToValue[FasciaTopTrimSize.TWO_INCH],
      eaveFasciaSize: 8,
      rakeFasciaSize: 8,
      rakeFriezeBoard: defaultFriezeBoardSettings,
      includeFriezeBoardOnPorches: true,
    },
    dormer: defaultHomeSettings.dormer,
    wainscoting: {
      ...defaultWainscotingSettings,
      height: 148,
      wainscotingMode: StreetOrientationMode.FRONT_FACES,
      closeDist: 2,
    },
    structure: {
      type: SettingsType.STRUCTURE_SETTINGS,
      maxUnsupportedCornerSpan: 36,
    },
    porch: defaultBrockPorchSettings,

    exteriorProps: {
      type: SettingsType.EXTERIOR_PROP_SETTINGS,
      propTypes: {
        ...defaultExteriorPropCatalog,
        garageDoorSingle: {
          ...defaultExteriorPropCatalog[BuiltInExteriorPropId.GARAGEDOORSINGLE],
          propAssetId: PropId.DoorGar_S8x7_2x4_01,
        },
        garageDoorDouble: {
          ...defaultExteriorPropCatalog[BuiltInExteriorPropId.GARAGEDOORDOUBLE],
          propAssetId: PropId.DoorGar_D16x7_2x4_01,
        },
        doorSingleGlass: {
          ...defaultExteriorPropCatalog[BuiltInExteriorPropId.DOORSINGLEGLASS],
          propAssetId: PropId.DoorExt_Single36_Strip3_02,
        },
        doorSingleGlassLow: {
          ...defaultExteriorPropCatalog[BuiltInExteriorPropId.DOORSINGLEGLASSLOW],
          propAssetId: PropId.DoorExt_Single36_Strip3_01,
        },
      },
    },
  },
};

export default brockMaterials;
